import { inject } from "aurelia-framework";
import { default as _ } from "underscore";
import { default as routerHelper } from "helpers/routerHelper";
import { default as currencyHelper } from "helpers/currencyHelper";
import { default as enumHelper } from "helpers/enumHelper";
import { default as workflowService } from "services/workflowService";
import { default as documentHelper } from "helpers/documentHelper";
import { WorkflowTransactionType } from "api/enums/workflow-transaction-type";

@inject(WorkflowTransactionType)
export class Approval {
    currencyHelper = currencyHelper;
    routerHelper = routerHelper;
    approvals = [];

    constructor(WorkflowTransactionType) {
        this.workflowTransactionTypes = WorkflowTransactionType;
    }

    async activate() {
        return await this.loadData();
    }

    async loadData() {
        this.approvals = await workflowService.getApprovals();
    }

    goTo(action, actionId) {
        routerHelper.navigate(routerHelper.getRelativeUrl(actionId + "/" + action));
    }

    checkAndOpenDocument(approval) {
        const item = { Id: approval.DocumentId };
        const document = documentHelper.reformDocument(item);
        documentHelper.openDocument(document);
    }
}
